<template>
    <div>
        <div class="mySwiper" id="mySwiper1" v-if="mainSwiperList.length>0">
            <div class="swiper-container ">
                <div class="swiper-wrapper">
                    <div class="swiper-slide cursorPointer" v-for="item in mainSwiperList" :key="item.comicId"> 
                        <!--   @click="dianji(item.comicId)" -->
                        <img  @dragstart.prevent  width="200px" :src="item.realCoverUrl" alt=""/>
                    </div>
                </div>
            </div>
            <!-- 框 -->
            <div class="leftBg"><img  @dragstart.prevent  src="../assets/mask_left.png" alt=""></div>
            <div class="rightBg"><img  @dragstart.prevent  src="../assets/mask_right.png" alt=""></div>
            <div class="bg_line leftBg_line_top" v-if="mainSwiperList.length>0"></div>
            <div class="bg_line leftBg_line_end" v-if="mainSwiperList.length>0"></div>
            <div class="bg_line rightBg_line_top" v-if="mainSwiperList.length>0"></div>
            <div class="bg_line rightBg_line_end" v-if="mainSwiperList.length>0"></div>
            <div class="bg_line left_box" v-if="mainSwiperList.length>0"></div>
            <div class="bg_line right_box" v-if="mainSwiperList.length>0"></div>
            <!-- 箭头-下一页/上一页 -->
            <div class="swiper-button-prev" @click="prev()"></div>
            <div class="swiper-button-next" @click="next()"></div>

        </div>
        <!-- 分类入口 -->
        <!-- <div class="mysort" v-show="props.showCategory">
            <div class="mysort-item cursorPointer" v-for="item in categoryList" :key="item.id" @click="navTo('/categorize',{id:item.id})">
                <span>{{item.categoryName}}</span>
            </div>
            <div class="mysort-item mysort-item-all cursorPointer" @click="navTo('/categorize',{id:0})">
                <span >全部</span>
                <img  @dragstart.prevent  src="../assets/icon_cat_quanbu.png" alt="" />
            </div>
        </div> -->
    </div>
</template>

<script setup>
    import Swiper from 'swiper';
    import 'swiper/swiper-bundle.css';
    import { onMounted, onUnmounted, ref } from 'vue';
    import {homeCarouselChart, homeComicCategory} from '@/utils/api'
    import { navTo, navToDetail } from '../utils/utils'
    const props = defineProps({
        showCategory: false,
    })
    let swiper = null
    let tout = null
    let mainSwiperList=ref([])
    let categoryList=ref([])
    
    onMounted(()=>{
        
        homeCarouselChart().then(res=>{
            mainSwiperList.value = res.data
            setTimeout(() => { // 下一个UI帧再初始化swiper
                initSwiper();
            });
            // setTimeout(()=>{
            //     swiper = new Swiper('.swiper-container', {
            //         loop: true,
            //         centeredSlides: true,
            //         slidesPerView: 'auto',
            //         loopedSlides: 3,
            //         spaceBetween: 0,
            //         speed:500,
            //         allowTouchMove:false,
            //         navigation: {
            //             nextEl: '.swiper-button-next',
            //             prevEl: '.swiper-button-prev',
            //         },
            // }); 
            // countWidth()
            // })
        })
        // if(props.showCategory){
        //     homeComicCategory().then(res=>{
        //         categoryList.value = res.data
        //     })
        // }
        
        window.addEventListener('resize', function(e) {
            // 在这里编写处理视口大小变化的代码
            countWidth()
        });
    })
    let initSwiper=()=>{
        swiper =  new Swiper('.swiper-container', {
                loop: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                loopedSlides: 3,
                spaceBetween: 0,
                speed:500,
                allowTouchMove:false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on:{   //事件
                  click:(event) =>{
                  //event.target 为dom元素，可以按需求取它的class或者其他属性
                  //我的是img所以我取的src属性
                    let src =  event.clickedSlide.firstElementChild.src 
                     mainSwiperList.value.map(item =>{ 
                      if(src.indexOf(item.realCoverUrl) != -1) {
                        dianji(item.comicId) // 执行想要执行的方法
                      }
                    })
                  }
                }
            });
        countWidth()
    }
    let countWidth = ()=>{
        let line = document.getElementsByClassName('bg_line')
        let dom = document.getElementsByClassName('swiper-slide-active')[0]
        if(dom){
            let active = dom.getBoundingClientRect();
            line[0].style.maxWidth = active.left - 50 + 'px'
            line[1].style.maxWidth = active.left - 50 + 'px'
            line[2].style.maxWidth = active.left - 50 + 'px'
            line[3].style.maxWidth = active.left - 50 + 'px'
            line[4].style.maxWidth = active.left - 30 + 'px'
            line[5].style.maxWidth = active.left - 30 + 'px'
        }
    }
    let next = ()=>{
        swiper.slideNext()
    }
    let prev = ()=>{
        swiper.slidePrev()
    }
    let dianji=(comicId)=>{
        navToDetail(comicId)
    }
</script>

<style lang="scss" scoped>
    .mySwiper{
        // max-width: 2000px;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding-bottom: 23px;
        background-color: #363347;
        .swiper-slide{
            width: 100%;
            max-width: 720px;
            height: 420px !important;
            img{
                width: 100%;
                // max-width: 720px;
                height: 420px !important;
            }
        }
        .kuang{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 2;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .leftBg{
            width: 86px;
            height: 420px;
            position: absolute;
            left: calc((100% - 700px) / 2 - 65px);
            top: 0;
            z-index: 2;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .rightBg{
            width: 86px;
            height: 420px;
            position: absolute;
            right: calc((100% - 700px) / 2 - 63px);
            top: 0;
            z-index: 2;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .bg_line{
            width: 50%;
            height: 10px;
            position: absolute;
            z-index: 2;
            background-color: #363347;
        }
        .leftBg_line_top{
            left: 0;
            top: 0;
        }
        .leftBg_line_end{
            left: 0;
            bottom: 23px;
        }
        .rightBg_line_top{
            right: 0;
            top: 0;
        }
        .rightBg_line_end{
            right: 0;
            bottom: 23px;
        }
        .left_box{
            height: 400px;
            background: linear-gradient(90deg, rgba(0, 0, 0, .5) 0%, #ffffff00 120%);
            top: 10px;
        }
        .right_box{
            height: 400px;
            background: linear-gradient(270deg, rgba(0, 0, 0, .5) 0%, #ffffff00 120%);
            top: 10px;
            right: 0;
        }
        .swiper-button-prev,.swiper-button-next{
            width: 60px;
            height: 60px;
            position: absolute;
            z-index: 9;
            top: 200px;
            border-radius: 50%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
        }
        .swiper-button-prev{
            left: 228px;
            background-image: url('../assets/icon_zuohua.png');
        }
        .swiper-button-next{
            right: 228px;
            background-image: url('../assets/icon_youhua.png');
        }
        .swiper-button-prev:after, .swiper-button-next:after{
            content:''
        }
    }
    .mysort{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 23px;
        background-color: #363347;
        &-item{
            margin-right: 36px;
            span{
                font-size: 16px;
                line-height: 24px;
                color: #C2C2C2;
            }
        }
        &-item:hover{
            span{
                color: #fff;
            }
        }
        &-item-all{
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                color: #FFFFFF !important;
            }
            img{
                width: 16px;
                height: 16px;
                margin-left: 4px;
            }
        }
    }
</style>